import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	modal: {
		height: '100%',
		padding: `0 ${theme.spacing.small}`,
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.medium,
	},
	title: {
		fontSize: theme.fontSize.xSmall,
	},
	description: {
		textAlign: 'center',
	},
}));
